<template>
  <tr>
    <td :data-th="'Název'" class="first_data"><strong>{{ getRoleName(name) }}</strong></td>
    <td :data-th="'Vytváření'">
      <select-box
          v-if="hasOperation('create')"
          :id="'createselectbox-'+id"
          :options="roleOptions"
          :value="content.create"
          @input="onChange($event, 'create')"
          :disabled="!isEditable"
      >
      </select-box>
    </td>
    <td :data-th="'Čtení'">
      <select-box
          v-if="hasOperation('read')"
          :id="'readselectbox-'+id"
          :options="roleOptions"
          :value="content['read']"
          @input="onChange($event, 'read')"
          :disabled="!isEditable"
      >
      </select-box>
    </td>
    <td :data-th="'Úprava'">
      <select-box
          v-if="hasOperation('update')"
          :id="'updateselectbox-'+id"
          :options="roleOptions"
          :value="content.update"
          @input="onChange($event, 'update')"
          :disabled="!isEditable"
      >
      </select-box>
    </td>
    <td :data-th="'Mazání'">
      <select-box
          v-if="hasOperation('delete')"
          :id="'deleteselectbox-'+id"
          :options="roleOptions"
          :value="content.delete"
          @input="onChange($event, 'delete')"
          :disabled="!isEditable"
      >
      </select-box>
    </td>
  </tr>
</template>

<script>
export default {
  name: "RoleGroupsSelectRow",
  props: {
    id: String,
    name: String,
    operations: Array,
    type: String,
    value: Object,
    isEditable: Boolean,
    isUser: Boolean,
  },
  data() {
    return {
      content: this.value,
    };
  },
  computed: {
    roleOptions() {
      let options = [];
      if (this.isUser) {
        options.push({id: null, text: this.$gettext('Ze skupiny oprávnění')});
      }
      options.push({id: "NONE", text: this.$gettext("Žádné")});
      if(this.type === 'operator_only'){
        options.push({id: "OWN", text: this.$gettext("Pouze svoje")});
      }else if(this.type === 'operator_and_global'){
        options.push({id: "OWN", text: this.$gettext("Pouze svoje")});
        options.push({id: "GLOBAL", text: this.$gettext("Pouze globální")});
        options.push({id: "OWN_AND_GLOBAL", text: this.$gettext("Svoje a globální")});
      }
      options.push({id: "ALL", text: this.$gettext("Všechny")});

      return options;
    }
  },
  methods: {
    getRoleName(name){
      switch (name) {
        case "Základní konfigurace":
          return this.$gettext("Základní konfigurace");
        case "Marketingová oznámení":
          return this.$gettext("Marketingová oznámení");
        case "API":
          return this.$gettext("API");
        case "Plátci":
          return this.$gettext("Plátci");
        case "Blokovaný obsah":
          return this.$gettext("Blokovaný obsah");
        case "Domény brandu":
          return this.$gettext("Domény brandu");
        case "Brandy":
          return this.$gettext("Brandy");
        case "Business modely":
          return this.$gettext("Business modely");
        case "Výběr operátora":
          return this.$gettext("Výběr operátora");
        case "Skupiny kanálů":
          return this.$gettext("Skupiny kanálů");
        case "Kanály":
          return this.$gettext("Kanály");
        case "Kodeky":
          return this.$gettext("Kodeky");
        case "Zdroje obsahu":
          return this.$gettext("Zdroje obsahu");
        case "Crony":
          return this.$gettext("Crony");
        case "Měny":
          return this.$gettext("Měny");
        case "Vlastní exporty":
          return this.$gettext("Vlastní exporty");
        case "Dashboard carousely":
          return this.$gettext("Dashboard carousely");
        case "Konfigurace zařízení":
          return this.$gettext("Konfigurace zařízení");
        case "Device log Viewer":
          return this.$gettext("Device log Viewer");
        case "Profily zařízení":
          return this.$gettext("Profily zařízení");
        case "Číst Token zařízení":
          return this.$gettext("Číst Token zařízení");
        case "Typy zařízení":
          return this.$gettext("Typy zařízení");
        case "Zařízení":
          return this.$gettext("Zařízení");
        case "Ke stažení":
          return this.$gettext("Ke stažení");
        case "Inicializační proces zařízení":
          return this.$gettext("Inicializační proces zařízení");
        case "Lokality":
          return this.$gettext("Lokality");
        case "Oznámení":
          return this.$gettext("Oznámení");
        case "Operátorské štítky":
          return this.$gettext("Operátorské štítky");
        case "Operátoři":
          return this.$gettext("Operátoři");
        case "Optimalizace":
          return this.$gettext("Optimalizace");
        case "Balíčky":
          return this.$gettext("Balíčky");
        case "Protokoly":
          return this.$gettext("Protokoly");
        case "Registrované MAC adresy":
          return this.$gettext("Registrované MAC adresy");
        case "Reporty":
          return this.$gettext("Reporty");
        case "Skupiny oprávnění":
          return this.$gettext("Skupiny oprávnění");
        case "Váhy služeb":
          return this.$gettext("Váhy služeb");
        case "Služby":
          return this.$gettext("Služby");
        case "Profily streamu":
          return this.$gettext("Profily streamu");
        case "Odběratelé":
          return this.$gettext("Odběratelé");
        case "Štítky":
          return this.$gettext("Štítky");
        case "Tématické skupiny kanálů":
          return this.$gettext("Tématické skupiny kanálů");
        case "Vypnout cache zařízení":
          return this.$gettext("Vypnout cache zařízení");
        case "Uživatelé":
          return this.$gettext("Uživatelé");
        case "Přesměrování aplikací":
          return this.$gettext("Přesměrování aplikací");
        case "Videotéka":
          return this.$gettext("Videotéka");
        default:
          return name;
      }
    },
    onChange(value, type) {
      this.content[type] = value;
      this.content['read'] = this.getReadValue(this.content['read']);
      this.$emit('input', this.content);
    },
    getReadValue(readValue){
      if(readValue == null){
        return null;
      }
      let values = [this.content.create, this.content.delete, this.content.update];
      if(values.includes('ALL')){
        return 'ALL';
      }
      if(values.includes('OWN_AND_GLOBAL')){
        return 'OWN_AND_GLOBAL';
      }
      if(values.includes('OWN') && values.includes('GLOBAL'))
      {
        return 'OWN_AND_GLOBAL';
      }
      if(readValue == 'NONE'){
        if(values.includes('OWN')){
          return 'OWN';
        }
        if(values.includes('GLOBAL')){
          return 'GLOBAL';
        }
      }
      return readValue;
    },
    hasOperation(type) {
      return this.operations.includes(type);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/forms/RoleGroupsSelectRow.vue